import Signout from './Signout';

export default Signout
export { Signout as Base }
